import VBaseInput from './VBaseInput';
import VBaseInputContextProvider from './VBaseInputContextProvider';
import type { VBaseInputProps } from './type';

const VBaseInputWrapper = (
  props: React.PropsWithChildren<VBaseInputProps> &
    React.RefAttributes<HTMLDivElement>,
) => {
  return (
    <VBaseInputContextProvider size={props.size}>
      <VBaseInput {...props} />
    </VBaseInputContextProvider>
  );
};

export default VBaseInputWrapper;
